.tableWrap {
  overflow-x: auto;
  padding-bottom: 8px;
}

.off b,
.off .muted {
  color: var(--muted);
}

.muted {
  color: var(--muted);
  font-size: 13px;
}

.slug {
  font-family: ui-monospace, Menlo, Consolas, monospace;
  font-size: 12px;
  color: var(--muted);
}

.mono {
  font-family: ui-monospace, Menlo, Consolas, monospace;
}

.table {
  min-width: 640px;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.row {
  display: grid;
  grid-template-columns: 44px minmax(0, 1.2fr) minmax(0, 1.6fr) 90px 80px auto;
  gap: 12px;
  align-items: start;
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
}

.row > span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.head {
  color: var(--muted);
  font-size: 12px;
  padding-block: 10px;
}

.grip {
  all: unset;
  box-sizing: border-box;
  width: 32px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: var(--muted);
  font-size: 18px;
  letter-spacing: -2px;
}

.grip:hover:not(:disabled) {
  background: var(--pill-bg);
  color: var(--text);
}

.grip:disabled {
  opacity: 0.4;
  cursor: default;
}

.grip:focus-visible,
.switch:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

.switch {
  all: unset;
  cursor: pointer;
  position: relative;
  width: 38px;
  height: 22px;
  border-radius: 999px;
  background: var(--line);
}

.switch::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--surface);
}

.switch[aria-checked='true'] {
  background: var(--ok);
}

.switch[aria-checked='true']::after {
  transform: translateX(16px);
}

.switch:disabled {
  opacity: 0.5;
  cursor: default;
}

@media (prefers-reduced-motion: no-preference) {
  .switch,
  .switch::after {
    transition: background 0.2s, transform 0.2s;
  }
}

.actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.small {
  padding: 5px 12px;
  font-size: 13px;
}

.form {
  display: grid;
  gap: 12px;
  margin-block: 12px;
}

@media (max-width: 860px) {
  .hintCol {
    display: none;
  }

  .table {
    min-width: 0;
  }

  .row {
    grid-template-columns: 36px minmax(0, 1fr) 44px 44px 92px;
    gap: 8px;
  }

  .head {
    font-size: 11px;
  }

  .actions {
    flex-direction: column;
    align-items: stretch;
  }
}
